import { render, staticRenderFns } from "./ScoreWebsite.vue?vue&type=template&id=3d3b118f&"
import script from "./ScoreWebsite.vue?vue&type=script&lang=js&"
export * from "./ScoreWebsite.vue?vue&type=script&lang=js&"
import style0 from "./ScoreWebsite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports